<template>
  <section v-maximizable>
    <div class="table-tab">
    <div class="table-tab__actions-block" v-if="canEdit">
      <table class="table-tab__block table" style="width: 140px">
        <thead class="table-tab__thead">
          <tr class="table-tab__row-auto-height">
            <th>{{$t('labels.actions')}}</th>
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
          <template  v-for="(item, rowId) in info">
            <tr class="table-tab__row-auto-height table-tab__tr table-tab__tr-border">
              <template v-if="item.editable">
                <th class="table-tab__actions table-tab__actions--redaction u-align-items-start">
                  <div class="table-tab__actions">
                    <button type="button" @click="onSaveChangesClick" :title="$t('buttons.save')">
                      <img class="table-tab__img-4" src="@/assets/img/static/tab-ok.svg" alt="">
                    </button>
                    <button type="button" @click="onDiscardChangesClick" :title="$t('buttons.cancel')">
                      <img class="table-tab__img-5" src="@/assets/img/static/tab-close.svg" alt="">
                    </button>
                  </div>
                </th>
              </template>
              <template v-else>
                <th class="table-tab__actions">
                  <div class="table-tab__actions">
                    <button type="button" :title="$t('buttons.modify')" @click="onEditItemClick(rowId)" :disabled="hasEditable && hasEditable.row !== rowId">
                      <img class="table-tab__img-1" src="@/assets/img/static/b-icon_edit.svg" alt="">
                    </button>
                    <button type="button" :title="$t('buttons.copy')" @click="onCopyItemClick(rowId)">
                      <img class="table-tab__img-2" src="@/assets/img/static/b-icon_add-compare.svg" alt="">
                    </button>
                    <button type="button"  :title="$t('buttons.delete')" @click="onRemoveItemClick(rowId)">
                      <img class="table-tab__img-3" src="@/assets/img/static/trashcan.svg" alt="">
                    </button>
                  </div>
                </th>
              </template>
            </tr>

            <template v-for="part in item.parts" v-if="validateParts">
              <tr class="table-tab__open table-tab__row-auto-height" v-if="item.editable || part > 0">
                <td class="table-tab__th"></td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <div class="table-tab__container"
         style="overflow: hidden; overflow-x: auto; outline: none;"
         :style="`max-width: calc(100% - ${canEdit ? '140px' : 0})`">
      <table class="table-tab__block table " style="min-width: 1400px">
        <thead class="table-tab__thead">
          <tr class="table-tab__row-auto-height">
            <th class="table-tab__width-90 table-tab__th--row">№</th>
            <th>{{$t('form.lot.specs.nomenclature')}}</th>
            <th>Ед. Измерения/удельный вес</th>
            <th>{{$t('form.lot.specs.quantity')}}</th>
            <th>{{$t('form.lot.specs.price-per-unit')}}</th>
            <th>{{$t('form.lot.specs.total-price')}}</th>
            <th>{{$t('form.lot.specs.currency')}}</th>
            <th>Валюта предложения</th>
            <th>Валюта оплаты по договору</th>
            <th>Валютная оговорка, если предусмотрена возможность по совокупности валют</th>
<!--            <th class="table-tab__width-140"></th>-->
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
          <template v-for="(item, i) in info">
            <tr class="table-tab__tr-border table-tab__row-auto-height">
              <!-- item order-->
              <th class="table-tab__th table-tab__th--row table-tab__btn-open">
                <img src="@/assets/img/static/arrow-up.png" alt="">
                  {{i + 1}}
              </th>

              <!-- nomenclature-->
              <td v-if="item.editable">
                <div class="a-form-field" style="width: 180px">
                  <categories-search full-search v-model="item.catalog" @input="onCategoryChange($event, item)"></categories-search>
                </div>
              </td>
              <td v-else>{{item.catalog.name}}</td>

              <!-- unit or percent -->
              <td v-if="item.editable">
                <dropdown-new class="select-w-140"
                              :options="[
                                { id: false, name: item.okeiName ||  'из справочника' },
                                { id: true, name: '% процент'}
                              ]"
                              v-model="item.percent"
                              @change="onPercentChange(item)">
                </dropdown-new>
              </td>
              <td v-else>{{item.percent ? '% процент' : item.okeiName || 'из справочника'}}</td>

              <!-- quantity -->
              <td class="a-form-field">
                <template v-if="item.editable && !item.percent">
                  <input-float class="a-input table-tab__input-max-width-85"
                               v-model="item.count">
                  </input-float>
                  <span class="a-validation-error" v-if="$v.info && $v.info[i].count.$dirty && !$v.info[i].count.required">{{$t('validation-error.mandatory-field-short')}}</span>
                  <span class="a-validation-error" v-if="$v.info && $v.info[i].count.$dirty && !$v.info[i].count.format">{{$t('validation-error.invalid-form-short')}}</span>
                  <span class="a-validation-error" v-if="$v.info && $v.info[i].count.$dirty && !$v.info[i].count.properParts">{{$t('validation-error.sum-differs-by', {value: item.dParts})}}</span>
                </template>

                <span v-else-if="!item.editable && !item.percent">{{item.count}}</span>
                <template v-else>
                  <div>{{item.count | percent}}%</div>
<!--                  <span class="a-validation-error"-->
<!--                        v-if="$v.info && $v.info[i].count.$dirty && !$v.info[i].count.properParts">-->
<!--                    {{$t('validation-error.sum-differs-by', {value: $options.filters.percent(item.dParts) + '%'})}}-->
<!--                  </span>-->
                </template>


              </td>

              <!-- price per unit -->
              <td v-if="item.editable">
                <input-cost class="a-input table-tab__input-max-width-85"
                            v-model="item.price"
                            v-if="lot.currency.valueOf() !== enums.Currency.EMPTY"></input-cost>
                <span v-else>Валюта лота не указана</span>
              </td>
              <td v-else>{{item.price | price}}</td>

              <!-- total price -->
              <td v-if="item.percent">{{item.price | price}}</td>
              <td v-else>{{(item.price * item.count) | price}}</td>

              <!-- lot currency -->
              <td v-t="lot.currency.label"></td>

              <!-- bid currency -->
              <td>
                <dropdown-new :options="enums.Currency.options.NOT_EMPTY"
                              placeholder="Любая"
                              multiple
                              v-model="item.bidCurrency"
                              v-if="item.editable">
                </dropdown-new>
                <span v-else>{{item.bidCurrency.map(e => $t(e.label)) | fullList}}</span>
              </td>

              <!-- payment currency -->
              <td>
                <dropdown-new :options="enums.Currency.options.NOT_EMPTY"
                              placeholder="Любая"
                              multiple
                              v-model="item.payCurrency"
                              v-if="item.editable">
                </dropdown-new>
                <span v-else>{{item.payCurrency.map(e => $t(e.label)) | fullList}}</span>
              </td>

              <!-- currency clause -->
              <td>
                <dropdown-new class="select-w-180"
                              :options="enums.CurrencyClauseOptional.options.all"
                              v-model="item.currencyClause"
                              v-if="item.editable">
                </dropdown-new>
                <span v-else>{{$t(item.currencyClause.label)}}</span>
              </td>

<!--              <td class="table-tab__width-180"></td>-->
            </tr>

            <template v-for="(part, partId) in item.parts" v-if="validateParts">
              <tr class="table-tab__open table-tab__row-auto-height" v-if="item.editable || part > 0">
                <th class="table-tab__width-90 table-tab__th--row "></th>
                <td class="">
                  <label class="a-checkbox__label ">
                    <input class="a-checkbox__input" type="checkbox" :disabled="!item.editable || item.parts[partId] === 0" :checked="item.parts[partId] > 0">
                    <span class="a-checkbox__icon"><i></i></span>
                    <span class="a-checkbox__text">{{$t('form.lot.parts.part-number', {id: partId + 1})}}</span>
                  </label>
                </td>

                <td v-if="item.percent">%</td>
                <td v-else>{{item.okeiName}}</td>

                <td v-if="item.editable">
                  <input-percent class="a-input table-tab__input-max-width-85"
                                 v-model="item.parts[partId]"
                                 v-if="item.percent">
                  </input-percent>
                  <input-float class="a-input table-tab__input-max-width-85"
                               v-model="item.parts[partId]"
                               v-else>
                    </input-float>
                </td>
                <td v-else>
                  <span v-if="item.percent">{{part | percent}}</span>
                  <span v-else>{{part}}</span>
                </td>


                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
<!--                <td class="table-tab__width-180"></td>-->
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <div class="table-tab__btn-end" v-if="canEdit">
      <button @click="onAddItemClick" type="button" :disabled="hasEditable">
        <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
       {{$t('buttons.add-position-to-specification')}}
      </button>
    </div>
    <loading v-if="loading"></loading>
  </div>
  </section>
</template>

<script>
  import _ from 'lodash'
  import $ from 'jquery'
  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'
  import { required, numeric, decimal } from '@/validators'
  import { create, all } from 'mathjs'

  const math = create(all, {
    number: 'Fraction'
  });

  import CommonMixins from '../mixins/common'

  export default {
    props: {
      lot: Object,

      validateParts: {
        type: Boolean,
        default: true
      },

      isVisible: Boolean,
      permissions: Object
    },

    components: {
      CategoriesSearch
    },

    mixins: [
      CommonMixins
    ],

    data: () => ({
      hasEditable: null,
      info: [],
      backup: undefined
    }),

    computed: {
      canEdit() {
        return this.permissions.CAN_EDIT_FULL_LOT || this.permissions.CAN_EDIT_LOT_PARTIALLY
      }
    },

    watch: {
      'lot.specs': {
        handler: function() {
          this.info = _.cloneDeep(this.lot.specs);
        },
        immediate: true
      },

      isVisible(to, from) {
        if (!from && to) {
          this._updateTableRowsHeight();
        }
      }
    },

    validations() {
      if (this.hasEditable) {
        return {
          info: {
            [this.hasEditable.row]: {
              count: {
                required,
                format: decimal,
                properParts: (value, item) => {
                  if (!this.validateParts) {
                    return true;
                  }

                  const itemCount = math.fraction(value || 0);

                  const partsSum = item.parts.reduce((acc, e) => {
                    const v = math.fraction(e || 0);
                    return acc.add(v);
                  }, math.chain(0)).done();

                  item.dParts = math.format(math.abs(math.subtract(itemCount, partsSum)), { fraction: 'decimal' });

                  return math.equal(itemCount, partsSum);
                }
              }
            }
          }
        }
      }
      else {
        return {}
      }
    },

    mounted() {
      this._updateTableRowsHeight();
    },

    updated() {
      this._updateTableRowsHeight();
    },

    methods: {
      _updateTableRowsHeight() {
        const dataRows = $(this.$el).find('.table-tab__container .table-tab__row-auto-height');
        const controlRows = $(this.$el).find('.table-tab__actions-block .table-tab__row-auto-height');

        if (dataRows.length !== controlRows.length) {
          console.error('amount of data and control rows should be the same');
          return;
        }

        for (let i = 0; i < dataRows.length; ++i) {
          const $d = $(dataRows[i]);
          const $c = $(controlRows[i]);

          const height = Math.max($d.height(), $c.height());

          $d.height(height);
          $c.height(height);
        }
      },

      onCategoryChange(event, item) {
        item.okei = event.okeiId;
        item.okeiName = event.okeiName;
      },

      onAddItemClick() {
        if (this.hasEditable) {
          return
        }

        this.hasEditable = { mode: 'add', row: this.info.length };

        this.info.push({
          editable: true,
          catalog: undefined,
          percent: false,
          count: undefined,
          okei: undefined,
          price: undefined,
          bidCurrency: [],
          payCurrency: [],
          currencyClause: new this.enums.CurrencyClauseOptional(this.enums.CurrencyClauseOptional.NOT_SET),
          parts: new Array(this.lot.numberOfParts).fill(0)
        });
      },

      onEditItemClick(rowId) {
        if (this.hasEditable) return;

        this.hasEditable = { mode: 'update', row: rowId };
        this.backup = _.cloneDeep(this.info[rowId]);
        this.$set(this.info, rowId, { ... this.info[rowId], editable: true});
      },

      onCopyItemClick(rowId) {
        if (this.hasEditable) return;

        const row = this.info[rowId];

        this.commitAction({
          action: 'add',
          row
        });
      },

      onRemoveItemClick(rowId) {
        if (this.hasEditable) return;
        this.info.splice(rowId, 1);

        this.commitAction({
          action: 'remove',
          index: rowId
        });
      },

      onSaveChangesClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        // verify changes before saving them
        const changed = this.info[this.hasEditable.row];
        const row = this.hasEditable.row;
        const mode = this.hasEditable.mode;

        this.commitAction({
          action: mode,
          row: changed,
          index: row
        });
      },

      async commitAction(payload) {
        if (payload.action === 'add') {
          delete payload.row.editable;
          this.lot.specs.push(payload.row);
        }
        else if (payload.action === 'update') {
          delete payload.row.editable;
          this.$set(this.lot.specs, payload.index, payload.row);
        }
        else if (payload.action === 'remove') {
          this.lot.specs.splice(payload.index, 1);
        }

        this.hasEditable = null;
        this.backup = undefined;

        //this.onDiscardChangesClick();

        await this.checkForm();
      },


      onDiscardChangesClick() {
        // if backup property is not empty then we should restore this, otherwise we have to remove item with editable==true
        const index = this.hasEditable.row;
        this.hasEditable = null;

        if (this.backup && index !== -1) {
          this.$set(this.info, index, this.backup);
        }
        else if (index !== -1) {
          this.info.splice(index, 1);
        }
      },

      onPercentChange(item) {
        item.count = item.percent ? 10000 : 0;
        for (let i = 0; i < item.parts.length; ++i) {
          item.parts[i] = 0;
        }
      }
    }
  }
</script>

<style lang="scss" >
  .table-tab {
    .selectric-wrapper {
      width: inherit;
    }

    .select2-selection--single {
      height: 24px;
      padding: 1px 12px;

      .select2-selection__arrow b {
        top: 33%;
      }

      .select2-selection__rendered {
        font-size: 13px;
      }
    }
  }
</style>
